import PageNavBackLayoutCpt from '@/components/page/PageNavBackLayoutCpt';
import ListViewCpt from '@/components/list/ListViewCpt';
import PopSelect from '@/components/pop-select';
import { rqtPostProductListForSelect } from '@/services/wms/product';
import { rqtPostEquityInvestmentList } from "@/services/cms/customer";
import cptCmn from '@/mixin/cpt-cmn';
export default {
  components: {
    PageNavBackLayoutCpt,
    ListViewCpt,
    PopSelect
  },
  mixins: [cptCmn],
  data() {
    return {
      showPopup: false,
      btnLoading: false,
      listRequest: rqtPostEquityInvestmentList,
      codeResItems: [],
      searchForm: {
        productId: null,
        managerCode: null,
        branchId: null,
        storeId: null,
        agentId: null,
        departmentLeader: null,
        isSurvivingShare: null,
        customerNo: null,
        chnName: null
      },
      searchItems: [{
        title: '产品',
        type: 'dropdown',
        name: 'productId',
        request: rqtPostProductListForSelect,
        keyName: 'id',
        valueName: 'productName',
        paramName: 'param',
        selectedOptions: []
      }, {
        title: '存在存续份额',
        type: 'flatSelect',
        name: 'isSurvivingShare',
        mutiSelect: false,
        options: [{
          value: '是',
          key: 'Y'
        }, {
          value: '否',
          key: 'N'
        }],
        selectedOptions: []
      }, {
        title: '客户号',
        type: 'input',
        name: 'customerNo',
        mutiSelect: false,
        options: [],
        selectedOptions: []
      }, {
        title: '中文姓名',
        type: 'input',
        name: 'chnName',
        mutiSelect: false,
        options: [],
        selectedOptions: []
      }]
    };
  },
  mounted() {
    this.initResCodeType(this.codeResItems).then(res => {
      for (let item of this.searchItems) {
        for (let codeItem of res) {
          if (item.name == codeItem.dataIndex) {
            item.options = codeItem.dataRes.map(e => {
              return {
                key: e.code,
                value: e.codeName
              };
            });
            break;
          }
        }
      }
    });
  },
  computed: {
    noCondition() {
      for (let selectItem of this.searchItems) {
        if (selectItem.selectedOptions.length > 0) {
          return false;
        }
      }
      return true;
    }
  },
  methods: {
    showCondition() {
      this.showPopup = true;
    },
    onListDataChange() {
      if (this.btnLoading) {
        this.btnLoading = false;
      }
    },
    onSearch() {
      this.btnLoading = true;
      this.$refs['ListViewCpt'].initListData();
    },
    handlePopSelectConfirm(searchItems) {
      for (let searchItem of searchItems) {
        this.searchForm[searchItem.name] = searchItem.selectedOptions[0];
      }
      this.$refs['ListViewCpt'].initListData();
      this.showPopup = false;
    }
  }
};